import { useEffect, useState } from 'react'

const useGeolocation = () => {
  const [position, setPosition] = useState<Partial<GeolocationCoordinates>>({ latitude: 0, longitude: 0 })

  useEffect(() => {
    window.navigator.geolocation.getCurrentPosition(
      ({ coords }) => setPosition({ latitude: coords.latitude, longitude: coords.longitude }),
      (err) => console.error(err)
    )
  }, [])
  return position
}

export default useGeolocation
